import React from 'react'
import './styles.scss'

interface YoutubeEmbed {
  embedId: string
}

export const YoutubeEmbed = ({ embedId }: YoutubeEmbed) => (
  <div className='video-responsive'>
    <iframe
      width='853'
      height='480'
      src={`https://www.youtube.com/embed/${embedId}`}
      frameBorder='0'
      allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
      allowFullScreen
      title='Embedded youtube'
    />
  </div>
)
